import type { IconType } from '@factorialco/f0-react'
import { MoneyBag, People, Placeholder } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

const defaultIcon = Placeholder

export const useDataCatalogMetadata = () => {
  const dataCatalogMetadata: Record<string, { icon: IconType; label: string }> = {
    organization: {
      icon: People,
      label: i18n.t('ai_reports.data_catalog.organization'),
    },
    finance: {
      label: i18n.t('ai_reports.data_catalog.finance'),
      icon: MoneyBag,
    },
  } as const

  const getDataCatalogMetadata = (id: string) => {
    return (
      dataCatalogMetadata[id] ?? {
        icon: defaultIcon,
        id: 'other',
        label: i18n.t('ai_reports.data_catalog.other'),
      }
    )
  }

  return {
    getDataCatalogMetadata,
    dataCatalogMetadata,
  }
}
